module.exports = __webpack_public_path__ + "static/media/pic29.c61b08db.jpg";